import React, { forwardRef } from 'react'
import { PaginationRenderItemParams } from '@mui/material'
import PaginationBlock from '@mui/material/Pagination'
import PaginationItem from '@mui/material/PaginationItem'
import { styled } from '@mui/material/styles'
import Link from 'next/link'

import Color from '@ecm/ui/element/Color'

type PaginationProps = {
  className?: string
  currentPage: number
  pageSlug: string
  totalPages: number
}

export type PaginationLinkProps = {
  item: PaginationRenderItemParams
  pageSlug: string
}
export const PaginationLink = forwardRef<HTMLAnchorElement, PaginationLinkProps>(
  function PaginationLink({ item, pageSlug, ...props }: PaginationLinkProps, ref) {
    return (
      <Link
        href={{ pathname: item.page === 1 ? `/${pageSlug}` : `/${pageSlug}/page/${item.page}` }}
      >
        <a ref={ref} {...props}></a>
      </Link>
    )
  }
)

const Pagination = styled(({ className, currentPage, pageSlug, totalPages }: PaginationProps) => {
  return (
    <div className={className}>
      <PaginationBlock
        hideNextButton={currentPage === totalPages}
        hidePrevButton={currentPage === 1}
        page={currentPage}
        count={totalPages}
        renderItem={item => (
          <PaginationItem component={PaginationLink} pageSlug={pageSlug} item={item} {...item} />
        )}
      />
    </div>
  )
})({
  '.Mui-disabled svg': { display: 'none' },
  '.Mui-selected': { backgroundColor: `${Color.smoke.normal} !important` },
  '.MuiButtonBase-root.MuiPaginationItem-root': {
    '&:hover': {
      backgroundColor: Color.smoke.lightest,
    },
  },
  '.MuiPagination-ul li a': {
    color: Color.saint.normal,
    fontFamily: 'Mulish, sans-serif',
    fontSize: '1em',
  },
})

export default Pagination
